import React, { useState } from 'react';
import styles from './ThemeSelector.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const ThemeSelector = ({ values, setFieldValue }) => {
  return (
    <div className={styles['theme-selector']}>
      <p className={styles['input-title']}>Theme</p>
      <div className={styles['theme-options']}>
        <div
          className={styles['theme-card']}
          onClick={() => setFieldValue('Theme', 'white')}
          style={{
            border:
              values?.Theme === 'white'
                ? '1.5px solid #128DEA'
                : '1.5px solid transparent',
            backgroundColor: values?.Theme === 'white' ? '#E6F3FD' : '#fff',
          }}
        >
          <SvgWithBranding type='whiteTheme' />
          <p
            className={styles['theme-title']}
            style={{
              color: values?.Theme === 'white' ? '#128DEA' : '#011211',
            }}
          >
            White
          </p>
        </div>
        <div
          className={styles['theme-card']}
          onClick={() => setFieldValue('Theme', 'black')}
          style={{
            border:
              values?.Theme === 'black'
                ? '1.5px solid #128DEA'
                : '1.5px solid transparent',
            backgroundColor: values?.Theme === 'black' ? '#E6F3FD' : '#fff',
          }}
        >
          <SvgWithBranding type='blackTheme' />
          <p
            className={styles['theme-title']}
            style={{
              color: values?.Theme === 'black' ? '#128DEA' : '#011211',
            }}
          >
            Black
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThemeSelector;
